import { createContext } from 'react';
import { Report } from '../networking/analyses/report/Report';

export interface ReportProvider {
  report: Report;
  setReport: React.Dispatch<React.SetStateAction<Report>>;
}

export const ReportContext = createContext({} as ReportProvider);
